import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ThumbsUp, ThumbsDown } from 'react-feather';
import { useAxios } from '../../../hooks/useAxios';
import { ACTIONS } from '../Constants';
import { NOTIFICATION_SUBMIT_ACTION } from '../../../api/api';
import { notifications } from '../../../constants';
import { hideNotification, showNotification } from '../../../redux/notifications/actions';
import { useDispatch } from 'react-redux';

const iconStyles = {
  color: 'white',
  height: '16px',
  width: '16px',
};

const VoteButtonWrapper = ({ icon: Icon, onClick, fill, isSubmittingFeedback }) => {
  return (
    <IconButton disabled={isSubmittingFeedback} size="small" onClick={onClick}>
      <Icon style={{ ...iconStyles, ...(fill && { fill: 'white' }) }} />
    </IconButton>
  );
};

const SubmitInboundFeedbackOnNotif = ({ successMessage, notificationData }) => {
  const [feedbackVote, handleVote, isSubmittingFeedback] = useController({ data: notificationData });

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography>{successMessage}</Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography sx={{ color: 'white' }}>Was this helpful?</Typography>
        <VoteButtonWrapper
          disabled={isSubmittingFeedback}
          fill={feedbackVote === true}
          icon={ThumbsUp}
          onClick={() => handleVote(true)}
        />
        <VoteButtonWrapper
          disabled={isSubmittingFeedback}
          fill={feedbackVote === false}
          icon={ThumbsDown}
          onClick={() => handleVote(false)}
        />
      </Box>
    </div>
  );
};

export default SubmitInboundFeedbackOnNotif;

const useController = ({ data }) => {
  const [feedbackVote, setFeedbackVote] = useState(null);
  const dispatch = useDispatch();

  const { callAxios: submitFeedback, isLoading: isSubmittingFeedback } = useAxios({
    url: NOTIFICATION_SUBMIT_ACTION,
    method: 'post',
    callOnMount: false,
    onSuccess: () => {
      setTimeout(() => {
        dispatch(hideNotification());
      }, 500);
    },
    onError: (err) => {
      dispatch(showNotification(err || notifications.ERROR.something_wrong, 'error'));
    },
  });

  const handleVote = async (value) => {
    const payload = {
      notification_message: data?.notificationMessageId,
      action: ACTIONS.RECORD_FEEDBACK,
      action_data: {
        inapp_notification_id: data?.notificationId,
        is_helpful: value,
      },
    };

    await submitFeedback({
      data: payload,
    });

    setFeedbackVote(value);
  };

  return [feedbackVote, handleVote, isSubmittingFeedback];
};
